import * as React from 'react';
import { m } from 'framer-motion';
import usePopover from '@/hooks/usePopover';
import { createPortal } from 'react-dom';

import XCircle from 'components/Icons/XCircle';
import Microphone from 'components/Icons/Microphone';
import Buttons from 'components/Buttons';
import { mixpanelTrack } from '@providers/Mixpanel';
import MediaRecorder from './MediaRecorder';
import ChatDropDown from '../Chat/ChatDropDown';

type Props = {
  onSubmit: (url: string) => void;
  disabled: boolean;
  onFileUploadClicked: () => void;
};

const AddSound = ({ onSubmit, disabled, onFileUploadClicked }: Props): React.ReactElement => {
  const { isOpen, setIsOpen, menuRef, triggerRef } = usePopover('top-right');

  const handleSubmit = (url: string): void => {
    mixpanelTrack('InputComposer - audio recorded');
    onSubmit(url);
  };

  return (
    <>
      <Buttons
        ref={triggerRef}
        disabled={disabled}
        ariaLabel={'Record audio'}
        iconBefore={
          <m.div
            style={{
              alignItems: 'center',
              display: 'flex',
              height: '16px',
              justifyContent: 'center',
              width: '16px',
              willChange: 'transform',
            }}
            whileTap={{ scale: disabled ? 1 : 0.9 }}
          >
            {isOpen
              ? (
                <XCircle weight="fill" size={16} color={'var(--color-gray-50)'} />
              )
              : (
                <Microphone weight="fill" size={16} color={((disabled || isOpen) && 'var(--color-gray-50)') || 'var(--color-primary)'} />
              )}
          </m.div>
        }
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        Audio
      </Buttons>
      {isOpen && createPortal(
        <m.div ref={menuRef}>
          <ChatDropDown>
            <MediaRecorder onSubmit={handleSubmit} setPopoverOpen={setIsOpen} onFileUploadClicked={onFileUploadClicked} />
          </ChatDropDown>
        </m.div>,
        document.body,
      )}
    </>
  );
};

export default AddSound;
